import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutEquipmentTypeQuickInfo extends Layout {
    sourceEquipmentType: DataSource;
    textboxDescr: Textbox;
    textboxEquipLength: Textbox;
    textboxEquipWidth: Textbox;
    textboxId: Textbox;
    textboxPartnerValue: Textbox;
}
